var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4AC41638-CA22-4D47-90B6-8C5279776CCB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Settings_Signed_In",
    transform: "translate(-24, -116)",
    stroke: "#232631",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0, 96)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/icons24/Posts",
    transform: "translate(24, 20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "like_huge",
    transform: "translate(1, 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.9735982,1 L13.0264018,1 C15.8635202,1 16.9063823,1.2600561 17.9473611,1.81677766 C18.9112557,2.33227414 19.6677259,3.08874428 20.1832223,4.0526389 C20.7399439,5.0936177 21,6.13647983 21,8.9735982 L21,13.0264018 C21,15.8635202 20.7399439,16.9063823 20.1832223,17.9473611 C19.6677259,18.9112557 18.9112557,19.6677259 17.9473611,20.1832223 C16.9063823,20.7399439 15.8635202,21 13.0264018,21 L8.9735982,21 C6.13647983,21 5.0936177,20.7399439 4.0526389,20.1832223 C3.08874428,19.6677259 2.33227414,18.9112557 1.81677766,17.9473611 C1.2600561,16.9063823 1,15.8635202 1,13.0264018 L1,8.9735982 C1,6.13647983 1.2600561,5.0936177 1.81677766,4.0526389 C2.33227414,3.08874428 3.08874428,2.33227414 4.0526389,1.81677766 C5.0936177,1.2600561 6.13647983,1 8.9735982,1 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11,
    cy: 11,
    r: 4.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.323fd7fae35ea6411d62e48200675ba6.svg";
export { ForwardRef as ReactComponent };